export default "__VITE_ASSET__CBnoRfTp__"